import type { Currency, Language } from "./enums.ts";

// Суммы хранятся в минимальных единицах (тийин, цент) как bigint.
const MINOR_DIGITS: Record<Currency, number> = { UZS: 2, USD: 2 };

export function toMinor(major: number, currency: Currency): bigint {
  const factor = 10 ** MINOR_DIGITS[currency];
  return BigInt(Math.round(major * factor));
}

export function fromMinor(minor: bigint, currency: Currency): number {
  return Number(minor) / 10 ** MINOR_DIGITS[currency];
}

/** Конвертирует сумму в UZS по курсу «сколько сумов за 1 единицу валюты». */
export function convertToUzs(minor: bigint, currency: Currency, rateToUzs: number): bigint {
  if (currency === "UZS") return minor;
  return BigInt(Math.round(Number(minor) * rateToUzs));
}

export function convertFromUzs(minorUzs: bigint, currency: Currency, rateToUzs: number): bigint {
  if (currency === "UZS") return minorUzs;
  return BigInt(Math.round(Number(minorUzs) / rateToUzs));
}

function groupThousands(int: string): string {
  return int.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

export function formatMoney(minor: bigint, currency: Currency, lang: Language = "ru"): string {
  const negative = minor < 0n;
  const abs = negative ? -minor : minor;
  const major = fromMinor(abs, currency);
  const sign = negative ? "−" : "";
  if (currency === "USD") {
    const [int, frac] = major.toFixed(2).split(".") as [string, string];
    const body = frac === "00" ? groupThousands(int) : `${groupThousands(int)}.${frac}`;
    return `${sign}$${body}`;
  }
  const int = Math.round(major).toString();
  return `${sign}${groupThousands(int)} ${lang === "uz" ? "so'm" : "сум"}`;
}
